import React from 'react';

const  ReadyCar = ({ color = '#00B348' }) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0684 1.5C11.6216 1.5 12.8809 2.75925 12.8809 4.3125" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 9.75766L1.5 9.75016" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.5 9.75766L12 9.75016" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.5 9.75586L9.61275 11.0369C9.19275 11.6436 8.50125 12.0059 7.76325 12.0059H5.73675C4.99875 12.0059 4.30725 11.6436 3.88725 11.0369L3 9.75586" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.75 1.5V3" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.75 6V7.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.75 10.5V12" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.75 15V16.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M8.25 16.5H5.25C4.00725 16.5 3 15.4928 3 14.25V5.25C3 4.42125 3.67125 3.75 4.5 3.75H9C9.82875 3.75 10.5 4.42125 10.5 5.25V14.25C10.5 15.4928 9.49275 16.5 8.25 16.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.5 6.75H3" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default ReadyCar;

